import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
  type?: string;
  jsonLd?: object[];
}

function setMeta(attr: string, key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

const SITE = "https://dqxuaad.cn";

export default function Seo({ title, description, keywords, canonicalPath = "/", type = "website", jsonLd = [] }: SeoProps) {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", SITE + canonicalPath);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    // canonical link
    let canonical = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = SITE + canonicalPath;

    // cleanup previously injected JSON-LD scripts from this manager
    document.querySelectorAll('script[data-jsonld="gk"]').forEach((s) => s.remove());

    jsonLd.forEach((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.jsonld = "gk";
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });
  }, [title, description, keywords, canonicalPath, type]);

  return null;
}